(function(){
  var root=document.querySelector('[data-gbe-directory]');
  if(!root||root.getAttribute('data-gbe-optimized')==='1')return;
  root.setAttribute('data-gbe-optimized','1');
  root.setAttribute('data-nosnippet','');
  if(!root.getAttribute('role'))root.setAttribute('role','navigation');
  if(!root.getAttribute('aria-label'))root.setAttribute('aria-label','All TV spare-parts collections');

  var input=root.querySelector('[data-gbe-directory-search]');
  var clear=root.querySelector('[data-gbe-directory-clear]');
  var status=root.querySelector('[data-gbe-directory-status]');
  var empty=root.querySelector('[data-gbe-directory-empty]');
  if(!input||!clear||!status||!empty)return;

  var groupNodes=[].slice.call(root.querySelectorAll('[data-gbe-group]'));
  var groups=[];
  var items=[];
  var byKey=Object.create(null);
  var total=0;
  var formatter=new Intl.NumberFormat('en-IN');
  var frame=0;

  groupNodes.forEach(function(node){
    var groupItems=[].slice.call(node.querySelectorAll('.gbe-cd-item'));
    var group={node:node,items:groupItems,summary:node.querySelector('[data-gbe-group-summary]')};
    var key=node.getAttribute('data-group-key');
    groups.push(group);
    Array.prototype.push.apply(items,groupItems);
    if(key)byKey[key]=group;
  });
  total=items.length;

  items.forEach(function(item){
    var count=parseInt(item.getAttribute('data-count')||'0',10);
    var node=item.querySelector('[data-gbe-product-count]');
    if(node)node.textContent=formatter.format(count)+' '+(count===1?'product':'products');
  });

  if('contentVisibility' in document.documentElement.style&&!document.getElementById('gbe-cd-rendering-guard')){
    var style=document.createElement('style');
    style.id='gbe-cd-rendering-guard';
    style.textContent='@supports (content-visibility:auto){.gbe-cd-group[open] .gbe-cd-item{content-visibility:auto;contain-intrinsic-size:auto 78px}}';
    document.head.appendChild(style);
  }

  function setHidden(node,value){if(node.hidden!==value)node.hidden=value;}
  function setText(node,value){if(node&&node.textContent!==value)node.textContent=value;}

  function filter(){
    frame=0;
    var query=(input.value||'').trim().toLowerCase();
    var visibleTotal=0;
    groups.forEach(function(group){
      var visible=0;
      group.items.forEach(function(item){
        var match=!query||(item.getAttribute('data-search')||'').indexOf(query)!==-1;
        setHidden(item,!match);
        if(match)visible++;
      });
      visibleTotal+=visible;
      setHidden(group.node,visible===0);
      setText(group.summary,visible+' '+(visible===1?'collection':'collections'));
      if(query&&visible&&!group.node.open)group.node.open=true;
    });
    setHidden(clear,!query);
    setHidden(empty,visibleTotal!==0);
    setText(status,query?'Showing '+visibleTotal+' of '+total+' collections':'Showing all '+total+' collections');
  }

  function filterNow(){
    if(frame)cancelAnimationFrame(frame);
    filter();
  }

  function closestButton(node){
    while(node&&node!==root){
      if(node.nodeType===1&&node.tagName==='BUTTON')return node;
      node=node.parentNode;
    }
    return null;
  }

  input.addEventListener('input',function(){
    if(!frame)frame=requestAnimationFrame(filter);
  });

  root.addEventListener('click',function(event){
    var button=closestButton(event.target);
    if(!button)return;

    if(button.hasAttribute('data-gbe-directory-clear')){
      input.value='';
      filterNow();
      input.focus();
      return;
    }

    if(!button.hasAttribute('data-gbe-quick'))return;
    var group=byKey[button.getAttribute('data-gbe-quick')];
    if(!group)return;
    input.value='';
    filterNow();
    group.node.hidden=false;
    group.node.open=true;
    requestAnimationFrame(function(){group.node.scrollIntoView({behavior:'smooth',block:'start'});});
  });
})();
